import styled from 'styled-components'

const NoteContainer = styled.div`
  display: flex;
  padding-bottom: 20px;
`

NoteContainer.Avatar = styled.div`
  display: flex;
  flex: 0 0 60px;
`
NoteContainer.Main = styled.div`
  flex: 1 1 auto;
`

NoteContainer.Main.Header = styled.div`
  display: flex;
  align-items: center;
`

NoteContainer.Main.Header.Name = styled.span`
  color: #136cfb;
  font-weight: bold;
  margin-right: 10px;
`

NoteContainer.Main.Header.Date = styled.span`
  color: rgb(119, 119, 119);
  font-size: 1.1rem;
`

NoteContainer.Main.Header.More = styled.div`
  position: relative;
  color: rgb(119, 119, 119);
  font-size: 1.1rem;
  margin-left: 20px;
  cursor: pointer;

  .notes-more-options {
    svg {
      &:hover {
        fill: #136cfc;
      }
    }
  }

  .notes-more-options-active {
    svg {
      fill: #136cfc;
    }
  }
`

NoteContainer.Main.Header.MoreOptions = styled.div`
  width: 86px;
  position: absolute;
  top: 20px;
  left: -35px;
  border-radius: 4px;
  background: rgb(255, 255, 255);
  box-shadow: 0 3px 4px 1px #adb2b9;
  display: flex;
  flex-direction: column;
  z-index: 9999;

  span {
    font-size: 14px;
    margin-bottom: 5px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  .more-options-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px;
    &:hover {
      background: #f5f5f5;
    }
    img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
  }
`

NoteContainer.Main.Note = styled.div``

NoteContainer.Main.Footer = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
`

NoteContainer.Main.Footer.Link = styled.a`
  color: rgb(119, 119, 119);
  font-weight: bold;
  margin-right: 10px;
`

export { NoteContainer }
